import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface ConfirmationPopupOption{
  visible:boolean;
  message:string;
  confirmButtonText:string;
  rejectButtonText:string;
  normalButtonText:string;
  showCloseButtn:boolean;
  option:string;
}

export interface ConfirmationResponse{
  confirmation:boolean;
  option:string;
}

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.less']
})
export class ConfirmationPopupComponent implements OnInit {

  constructor() { }

  @Input() option:ConfirmationPopupOption;

  @Output() onConfirmed = new EventEmitter<ConfirmationResponse>();

  ngOnInit(): void {
  }

  onClick(res:boolean){
    this.onConfirmed.emit({confirmation:res,option: this.option.option});
  }

}
